
const apiUrl = 'https://dev.api.store.jiankanghao.net/api/v1/';//测试域名   
// const apiUrl = 'http://192.168.0.212:827/api/v1/';//测试域名 
// const apiUrl = 'http://proxy.jiankanghao.net:50069/api/v1/';//测试域名 
// const apiUrl = 'http://192.168.0.89:3004/api/v1/';//测试域名 
// const apiUrl = 'https://api.shop.jiankanghao.net/api/v1/';//线上

export default apiUrl


// WEBPACK FOOTER //
// ./src/util/api.js